import axios from 'axios';
import { ICrudGetAction, ICrudGetAllAction, ICrudPutAction, ICrudDeleteAction } from 'react-jhipster';

import { cleanEntity } from 'app/shared/util/entity-utils';
import { REQUEST, SUCCESS, FAILURE } from 'app/shared/reducers/action-type.util';

import { IGloballyFreeSubscriptionPlan, defaultValue } from 'app/shared/model/globally-free-subscription-plan.model';

export const ACTION_TYPES = {
  FETCH_GLOBALLYFREESUBSCRIPTIONPLAN_LIST: 'globallyFreeSubscriptionPlan/FETCH_GLOBALLYFREESUBSCRIPTIONPLAN_LIST',
  FETCH_GLOBALLYFREESUBSCRIPTIONPLAN: 'globallyFreeSubscriptionPlan/FETCH_GLOBALLYFREESUBSCRIPTIONPLAN',
  CREATE_GLOBALLYFREESUBSCRIPTIONPLAN: 'globallyFreeSubscriptionPlan/CREATE_GLOBALLYFREESUBSCRIPTIONPLAN',
  UPDATE_GLOBALLYFREESUBSCRIPTIONPLAN: 'globallyFreeSubscriptionPlan/UPDATE_GLOBALLYFREESUBSCRIPTIONPLAN',
  DELETE_GLOBALLYFREESUBSCRIPTIONPLAN: 'globallyFreeSubscriptionPlan/DELETE_GLOBALLYFREESUBSCRIPTIONPLAN',
  RESET: 'globallyFreeSubscriptionPlan/RESET',
};

const initialState = {
  loading: false,
  errorMessage: null,
  entities: [] as ReadonlyArray<IGloballyFreeSubscriptionPlan>,
  entity: defaultValue,
  updating: false,
  updateSuccess: false,
};

export type GloballyFreeSubscriptionPlanState = Readonly<typeof initialState>;

// Reducer

export default (state: GloballyFreeSubscriptionPlanState = initialState, action): GloballyFreeSubscriptionPlanState => {
  switch (action.type) {
    case REQUEST(ACTION_TYPES.FETCH_GLOBALLYFREESUBSCRIPTIONPLAN_LIST):
    case REQUEST(ACTION_TYPES.FETCH_GLOBALLYFREESUBSCRIPTIONPLAN):
      return {
        ...state,
        errorMessage: null,
        updateSuccess: false,
        loading: true,
      };
    case REQUEST(ACTION_TYPES.CREATE_GLOBALLYFREESUBSCRIPTIONPLAN):
    case REQUEST(ACTION_TYPES.UPDATE_GLOBALLYFREESUBSCRIPTIONPLAN):
    case REQUEST(ACTION_TYPES.DELETE_GLOBALLYFREESUBSCRIPTIONPLAN):
      return {
        ...state,
        errorMessage: null,
        updateSuccess: false,
        updating: true,
      };
    case FAILURE(ACTION_TYPES.FETCH_GLOBALLYFREESUBSCRIPTIONPLAN_LIST):
    case FAILURE(ACTION_TYPES.FETCH_GLOBALLYFREESUBSCRIPTIONPLAN):
    case FAILURE(ACTION_TYPES.CREATE_GLOBALLYFREESUBSCRIPTIONPLAN):
    case FAILURE(ACTION_TYPES.UPDATE_GLOBALLYFREESUBSCRIPTIONPLAN):
    case FAILURE(ACTION_TYPES.DELETE_GLOBALLYFREESUBSCRIPTIONPLAN):
      return {
        ...state,
        loading: false,
        updating: false,
        updateSuccess: false,
        errorMessage: action.payload,
      };
    case SUCCESS(ACTION_TYPES.FETCH_GLOBALLYFREESUBSCRIPTIONPLAN_LIST):
      return {
        ...state,
        loading: false,
        entities: action.payload.data,
      };
    case SUCCESS(ACTION_TYPES.FETCH_GLOBALLYFREESUBSCRIPTIONPLAN):
      return {
        ...state,
        loading: false,
        entity: action.payload.data,
      };
    case SUCCESS(ACTION_TYPES.CREATE_GLOBALLYFREESUBSCRIPTIONPLAN):
    case SUCCESS(ACTION_TYPES.UPDATE_GLOBALLYFREESUBSCRIPTIONPLAN):
      return {
        ...state,
        updating: false,
        updateSuccess: true,
        entity: action.payload.data,
      };
    case SUCCESS(ACTION_TYPES.DELETE_GLOBALLYFREESUBSCRIPTIONPLAN):
      return {
        ...state,
        updating: false,
        updateSuccess: true,
        entity: {},
      };
    case ACTION_TYPES.RESET:
      return {
        ...initialState,
      };
    default:
      return state;
  }
};

const apiUrl = 'api/globally-free-subscription-plans';

// Actions

export const getEntities: ICrudGetAllAction<IGloballyFreeSubscriptionPlan> = (page, size, sort) => ({
  type: ACTION_TYPES.FETCH_GLOBALLYFREESUBSCRIPTIONPLAN_LIST,
  payload: axios.get<IGloballyFreeSubscriptionPlan>(`${apiUrl}?cacheBuster=${new Date().getTime()}`),
});

export const getEntity: ICrudGetAction<IGloballyFreeSubscriptionPlan> = id => {
  const requestUrl = `${apiUrl}/${id}`;
  return {
    type: ACTION_TYPES.FETCH_GLOBALLYFREESUBSCRIPTIONPLAN,
    payload: axios.get<IGloballyFreeSubscriptionPlan>(requestUrl),
  };
};

export const createEntity: ICrudPutAction<IGloballyFreeSubscriptionPlan> = entity => async dispatch => {
  const result = await dispatch({
    type: ACTION_TYPES.CREATE_GLOBALLYFREESUBSCRIPTIONPLAN,
    payload: axios.post(apiUrl, cleanEntity(entity)),
  });
  dispatch(getEntities());
  return result;
};

export const updateEntity: ICrudPutAction<IGloballyFreeSubscriptionPlan> = entity => async dispatch => {
  const result = await dispatch({
    type: ACTION_TYPES.UPDATE_GLOBALLYFREESUBSCRIPTIONPLAN,
    payload: axios.put(apiUrl, cleanEntity(entity)),
  });
  return result;
};

export const deleteEntity: ICrudDeleteAction<IGloballyFreeSubscriptionPlan> = id => async dispatch => {
  const requestUrl = `${apiUrl}/${id}`;
  const result = await dispatch({
    type: ACTION_TYPES.DELETE_GLOBALLYFREESUBSCRIPTIONPLAN,
    payload: axios.delete(requestUrl),
  });
  dispatch(getEntities());
  return result;
};

export const reset = () => ({
  type: ACTION_TYPES.RESET,
});
